import React, { Component } from 'react';
import FormBuilderList from './FormBuilderList';
import FormBuilderEditor from './FormBuilderEditor';

export default class FormBuilderPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            view: 'list',
            editFormId: null
        };
    }

    handleEditForm = (formId) => {
        this.setState({ view: 'editor', editFormId: formId });
    };

    handleCreateForm = () => {
        this.setState({ view: 'editor', editFormId: null });
    };

    handleBack = () => {
        this.setState({ view: 'list', editFormId: null });
    };

    render() {
        return (
            <div className="clinic-contain">
                <div className="breadcrumb-bar">
                    <div className="container-fluid">
                        <div className="row align-items-center">
                            <div className="col-md-12 col-12">
                                <nav aria-label="breadcrumb" className="page-breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Admin
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Form Builder
                                        </li>
                                    </ol>
                                </nav>
                                <h2 className="breadcrumb-title">Form Builder</h2>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-3 py-2">
                    {this.state.view === 'editor' && (
                        <FormBuilderEditor formId={this.state.editFormId} onBack={this.handleBack} />
                    )}
                    {this.state.view !== 'editor' && (
                        <FormBuilderList onEditForm={this.handleEditForm} onCreateForm={this.handleCreateForm} />
                    )}
                </div>
            </div>
        );
    }
}
